/* src/Pages/PreOrder/PreOrderUpload/components/SubmissionFeedbackModal.js */
import React from "react";

const SubmissionFeedbackModal = ({
  isOpen,
  onClose,
  imagePreview,
  formData,
  formConfig,
  showImageSection = true,
  showEventButton = false,
}) => {
  // Navigate to the main event page
  const navigateToEventPage = () => {
    const currentPath = window.location.pathname;
    const eventPath = currentPath.replace("/upload", "");
    window.location.href = eventPath;
  };

  // Extract name for greeting (type-based detection)
  const getDisplayName = () => {
    const fields = formConfig?.fields || [];

    const firstNameField = fields.find((f) => f.type === "firstName");
    const lastNameField = fields.find((f) => f.type === "lastName");
    const fullNameField = fields.find((f) => f.type === "fullName");

    // Build the name string
    const nameParts = [];
    if (firstNameField && formData[firstNameField.id]) {
      nameParts.push(formData[firstNameField.id]);
    }
    if (lastNameField && formData[lastNameField.id]) {
      nameParts.push(formData[lastNameField.id]);
    }

    // If no separate names but we have full name
    if (nameParts.length === 0 && fullNameField && formData[fullNameField.id]) {
      return formData[fullNameField.id];
    }

    return nameParts.join(" ");
  };

  if (!isOpen) return null;

  const displayName = getDisplayName();

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal-content rtl">
        <h2 className="feedback-modal-title">
          {displayName ? `תודה רבה ${displayName}!` : "הטופס נשלח בהצלחה!"}
        </h2>

        <div className="feedback-modal-body">
          {showImageSection && imagePreview && (
            <div className="feedback-image-container">
              <img
                src={imagePreview}
                alt="התמונה שנשלחה"
                className="feedback-image"
              />
            </div>
          )}
        </div>

        <div className="feedback-buttons-container">
          {showEventButton ? (
            <button
              className="start-event-button"
              onClick={navigateToEventPage}
            >
              התחל ומצא את הראש שלך!
            </button>
          ) : (
            <button className="feedback-confirm-button" onClick={onClose}>
              אישור
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubmissionFeedbackModal;
